import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { userSelector } from "../../slices/userSlice";
import { UserName } from "components/common/UserName";
import { Nav } from "reactstrap";
import { cdn } from "constants/common";
var ps;
let userSlice;
function Sidebar(props) {
  const { t } = useTranslation();
  const location = useLocation();
  const sidebar = React.useRef();
  const activeRoute = (routeName) => {
    const pathSegments = location.pathname.split('/').filter(segment => segment);
    return "/" + pathSegments[pathSegments.length - 1] === routeName ? 'active' : "";
  };
  const mainRoutes = props.routes;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);

  const handleNavLinkClick = () => {
    if (window.innerWidth <= 991) {
      props.toggleSidebar();
    }
  };

  useEffect(() => {
    userSlice = require("../../slices/userSlice")
  }, [])

  const handleLogout = () => {
    navigate('/login', { replace: true });
    dispatch(userSlice.logout());
  };

  return (
    <>
      <div
        className={`sidebar ${props.isSidebarOpen ? "toggled" : ""}`}
        data-color={props.bgColor}
        data-active-color={props.activeColor}
      >
        <div className="logo">
          <button className="close_side" onClick={props.toggleSidebar}>✕</button>
          <Link to="/" className="simple-text logo-mini">
            <div className="logo-img">
              <img src="/images/logo-nav.png" alt="react-logo" />
              <img src="/images/logo-fill.png" alt="react-logo" style={{ height:'auto' }}/>
            </div>
          </Link>
        </div>
        <div className="side_user_row">
          <div className="side_user_image">
            {/* <img src="/images/default-person.png" alt="" /> */}
             <img className="rounded-circle" src={user?.user?.image ? (cdn + user?.user?.image) : '/images/default-person.png'} alt="" />
          </div>
          <div className="side_user_title">
            <span>{t("sidebar.welcome")}</span>
            <UserName name={user?.user?.name} lastName={user?.user?.last_name} />
          </div>
        </div>
        <div className="sidebar-wrapper" ref={sidebar}>
          <Nav>
            {/* Main Section */}
            <li><p className="nav_head">{t("sidebar.general")}</p></li>

            {mainRoutes.map((prop, key) => {
              return (
                !prop?.subRoute && <li
                  className={
                    activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
                  }
                  key={key}
                >
                  <NavLink to={prop.layout + prop.path} className="nav-NavLink" onClick={handleNavLinkClick}>
                    <div className="line_wrap">
                      <img src={prop.icon} alt="side" />
                      <img src={prop.iconActive} alt="side" />
                      <h2>{prop.titleKey ? t(prop.titleKey) : (typeof prop.title === 'string' ? t(prop.title, { defaultValue: prop.title }) : prop.title)}</h2>
                    </div>
                  </NavLink>
                </li>
              );
            })}


            <li>
              <a href="" onClick={handleLogout} className="nav-NavLink p-0" >
                <div className="line_wrap wrap_logout">
                  <img src='/images/LogOut.png' alt="side" />
                  <img src='/images/LogOut-fill.png' alt="side" />
                  <h2>{t("header.logout")}</h2>
                </div>
              </a>
            </li>

          </Nav>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
